import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";

import Home from "@/pages/public/Home";
import LeTravail from "@/pages/public/LeTravail";
import Realisations from "@/pages/public/Realisations";
import RealisationDetail from "@/pages/public/RealisationDetail";
import CabinetsExpertise from "@/pages/public/CabinetsExpertise";
import Contact from "@/pages/public/Contact";
import MentionsLegales from "@/pages/public/MentionsLegales";
import MenuisierVille from "@/pages/public/MenuisierVille";

import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import AdminDemandes from "@/pages/admin/Demandes";
import AdminClients from "@/pages/admin/Clients";
import AdminDevis from "@/pages/admin/Devis";
import DevisEditor from "@/pages/admin/DevisEditor";
import DevisImport from "@/pages/admin/DevisImport";
import AdminFactures from "@/pages/admin/Factures";
import FactureEditor from "@/pages/admin/FactureEditor";
import FactureNew from "@/pages/admin/FactureNew";
import AdminRealisations from "@/pages/admin/Realisations";
import AdminTemoignages from "@/pages/admin/Temoignages";
import AdminParametres from "@/pages/admin/Parametres";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <span className="text-serial">Chargement</span>
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              {/* PUBLIC */}
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/le-savoir-faire" element={<LeTravail />} />
                <Route path="/le-travail" element={<Navigate to="/le-savoir-faire" replace />} />
                <Route path="/realisations" element={<Realisations />} />
                <Route path="/realisations/:slug" element={<RealisationDetail />} />
                <Route path="/cabinets-d-expertise" element={<CabinetsExpertise />} />
                {/* Local SEO pages — explicit routes for each city (react-router needs / before :param) */}
                <Route path="/menuisier-nantes" element={<MenuisierVille />} />
                <Route path="/menuisier-bouguenais" element={<MenuisierVille />} />
                <Route path="/menuisier-la-baule" element={<MenuisierVille />} />
                <Route path="/menuisier-pornichet" element={<MenuisierVille />} />
                <Route path="/menuisier-le-pouliguen" element={<MenuisierVille />} />
                <Route path="/menuisier-pornic" element={<MenuisierVille />} />
                <Route path="/menuisier-saint-brevin" element={<MenuisierVille />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
              </Route>

              {/* ADMIN */}
              <Route path="/admin/login" element={<Login />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="demandes" element={<AdminDemandes />} />
                <Route path="clients" element={<AdminClients />} />
                <Route path="devis" element={<AdminDevis />} />
                <Route path="devis/import" element={<DevisImport />} />
                <Route path="devis/nouveau" element={<DevisEditor />} />
                <Route path="devis/:id" element={<DevisEditor />} />
                <Route path="factures" element={<AdminFactures />} />
                <Route path="factures/new" element={<FactureNew />} />
                <Route path="factures/:id" element={<FactureEditor />} />
                <Route path="realisations" element={<AdminRealisations />} />
                <Route path="temoignages" element={<AdminTemoignages />} />
                <Route path="parametres" element={<AdminParametres />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="bottom-right" />
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
